import {issueHovercardPath} from '@github-ui/paths'
import {type SafeHTMLString, SafeHTMLBox} from '@github-ui/safe-html'
import {Link} from '@primer/react'
import {LABELS} from '../..'
import {TEST_IDS} from '../../constants'

export type HeaderTitleProps = {
  titleHTML: SafeHTMLString
  repoName: string
  repoOwner: string
  number: number
  url: string
}

export function HeaderTitle({titleHTML, repoName, repoOwner, number, url}: HeaderTitleProps) {
  return (
    <>
      <SafeHTMLBox
        as="bdi"
        sx={{
          wordBreak: 'break-word',
          mr: 1,
          overflow: 'hidden',
          ...{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            display: '-webkit-box',
          },
        }}
        className="markdown-title"
        html={titleHTML}
        data-testid={TEST_IDS.issueTitle}
      />
      <Link
        href={url}
        target="_blank"
        data-hovercard-url={issueHovercardPath({
          owner: repoOwner,
          repo: repoName,
          issueNumber: number,
        })}
        sx={{color: 'fg.muted', fontWeight: 'normal', display: 'inline'}}
      >
        {LABELS.issueNumber(number)}
      </Link>
    </>
  )
}

try{ HeaderTitle.displayName ||= 'HeaderTitle' } catch {}